(function() {
  'use strict';

  angular.module('$traineePlayer')
    .directive('mfThumbScroller', mfThumbScroller);

  mfThumbScroller.$inject = ['hmClickDefaults', '$window'];

  function mfThumbScroller(hmClickDefaults, $window) {
    return function(scope, elem, attrs) {
      var thumbScrollerLeftElem = angular.element(attrs.thumbScrollerLeft);
      var thumbScrollerRightElem = angular.element(attrs.thumbScrollerRight);

      var thumbWidth = 88;

      var halfWidth;
      var thumbData;
      var navigation;
      var numSlides;
      var unlockedSlides = 0;
      var selectedIdx;

      thumbScrollerLeftElem.hammer(hmClickDefaults, 'tap').on('tap', scrollLeft);
      thumbScrollerRightElem.hammer(hmClickDefaults, 'tap').on('tap', scrollRight);
      elem.hammer(hmClickDefaults, 'tap').on('tap', onSelectItem);
      angular.element($window).on('resize', setControlsSizes);

      setControlsSizes();

      function scrollToX(x) {
        elem.stop(true).animate({ scrollLeft: x }, 400, 'easeOutCubic');
      }

      function scrollLeft() {
        scrollToX(elem.scrollLeft() - halfWidth);
      }

      function scrollRight() {
        scrollToX(elem.scrollLeft() + halfWidth);
      }

      function centerOn(newElem) {
        newElem = newElem[0];
        var x = newElem.offsetLeft - newElem.offsetWidth / 2;
        scrollToX(x - halfWidth);
      }

      function onSelectItem(e) {
        var id = e.target.id;
        if (!id || id.indexOf('thumbItem') !== 0) return;

        var idx = parseInt(id.replace('thumbItem', ''));

        // not allowed to navigate next via here
        if (idx >= unlockedSlides) return;
        scope.$apply(function() {
          navigation.navigate(idx);
        });
      }

      function doSelectItem(newSelectedIdx) {
        angular.element('.thumb-scroller-item-selected').removeClass('thumb-scroller-item-selected');
        var selectedElem = elem.find('#thumbItem' + newSelectedIdx);
        selectedElem.addClass('thumb-scroller-item-selected');
        centerOn(selectedElem);
      }

      function updateUnlocked(prevUnlockedSlides, unlockedSlides) {
        var thumbElems = elem.children();
        for (var i = prevUnlockedSlides; i < unlockedSlides; i++)
          angular.element(thumbElems[i]).addClass('thumb-scroller-item-unlocked');
      }


      scope.$watch(attrs.thumbScrollerData, function(newValue) {
        thumbData = newValue;
        redraw();
      });

      scope.$watch(attrs.thumbScrollerNavigation, function(newValue) {
        if (!newValue || !newValue.numSlides)
          return;

        navigation = newValue;

        if (numSlides !== navigation.numSlides) {
          numSlides = navigation.numSlides;
          redraw();
        }

        if (selectedIdx !== navigation.slideIndex) {
          selectedIdx = navigation.slideIndex;
          doSelectItem(selectedIdx);
        }

        if (unlockedSlides !== navigation.numUnlockedSlides) {
          updateUnlocked(unlockedSlides, navigation.numUnlockedSlides);
          unlockedSlides = navigation.numUnlockedSlides;
        }
      }, true);

      function setControlsSizes() {
        halfWidth = parseInt(elem.css('width')) / 2;
      }

      function redraw() {
        if (!thumbData || !navigation)
          return;

        elem.html(makeThumbsHtml());
      }

      function makeThumbsHtml() {
        var html = [];
        for (var i = 0; i < numSlides; i++) {
          var chunkIdx = Math.floor(i / thumbData.thumbnailsPerChunk);
          var chunkThumbIdx = i % thumbData.thumbnailsPerChunk;

          html.push('<div class="thumb-scroller-item" id="thumbItem', i, '" style="background-image:url(\'', thumbData.urlTemplate.replace('{0}', chunkIdx), '\');background-position: ', -thumbWidth * chunkThumbIdx, 'px 0">',
            i + 1,
            '</div>');
        }

        return html.join('');
      }

      scope.$on('$destroy', function() {
        thumbScrollerLeftElem.off('tap');
        thumbScrollerRightElem.off('tap');
        elem.off('tap');
        angular.element($window).off('resize', setControlsSizes);
      });
    };
  }
})();
